import React, { Fragment, useState, useEffect } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import PropTypes from 'prop-types';

const ButtonClass =
    'w-12 h-12 rounded-full bg-white dark:bg-icoDarkMode-deepBlack dark:text-icoDarkmode-wolf flex items-center justify-center text-icoGray-500';

const CustomDashboardPopover = ({ panel, children, className = null, ...restProps }) => {
    const [referenceElement, setReferenceElement] = useState();
    const [popperElement, setPopperElement] = useState();
    let { styles, attributes, update } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-end',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10]
                }
            }
        ]
    });

    return (
        <Popover {...restProps}>
            {({ open }) => (
                <>
                    <Popover.Button
                        ref={setReferenceElement}
                        as="button"
                        id="option-dashboard"
                        aria-label="open-options-dashboard-view"
                        className={className ?? ButtonClass}>
                        {React.Children.map(children, (child) => {
                            const newChild = React.cloneElement(child, {
                                open
                            });
                            return newChild;
                        })}
                    </Popover.Button>
                    {createPortal(
                        <div
                            className="z-30"
                            ref={setPopperElement}
                            style={styles.popper}
                            {...attributes.popper}>
                            <Transition
                                as={Fragment}
                                enter="ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1">
                                <Popover.Panel>
                                    <WrapperPanel update={update}>{panel}</WrapperPanel>
                                </Popover.Panel>
                            </Transition>
                        </div>,
                        document.body
                    )}
                </>
            )}
        </Popover>
    );
};

const WrapperPanel = ({ update, children }) => {
    useEffect(() => {
        // Position problem so force the update to display the content at the right place
        if (typeof update === 'function') {
            update();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="w-32 rounded-md border border-white bg-white/80 font-GSemiBold shadow-icoXL backdrop-blur-sm firefox:bg-gradient-to-tr firefox:from-icoGrayFirefox-300 firefox:to-icoWhiteFirefox dark:border-icoDarkMode-deepBlack dark:bg-icoDarkMode-anthracite/80">
            {children}
        </div>
    );
};

CustomDashboardPopover.propTypes = {
    panel: PropTypes.node,
    children: PropTypes.node
};

export default CustomDashboardPopover;
